export default{
  setContact: (state, payload) => {state.contact = payload},
  setSocialMedia: (state, payload) => {state.socialMedia = payload},
}